import i18next from 'i18next';
import { initReactI18next } from 'react-i18next';
import en from './lng/en.json';
import uz from './lng/uz.json';
import ru from './lng/ru.json';

i18next.use(initReactI18next).init({
  lng: localStorage.getItem('i18lang') || 'en',
  fallbackLng: 'en',
  debug: true,
  resources: {
    en: {
      translation: en,
    },
    uz: {
      translation: uz,
    },
    ru: {
      translation: ru,
    },
  },
});

export default i18next;
